import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportingService } from '../reporting-service.service';
import { EngagementActivityVm } from 'app/Models/EngagementActivity';
import { ReportMainData } from 'app/ReportingModel/ReportFiltering';
@Component({
    selector: 'app-availability-by-forecasted-hours-report',
    templateUrl: './availability-by-forecasted-hours-report.component.html',
    styleUrls: ['./availability-by-forecasted-hours-report.component.scss']
})
export class AvailabilityByForecastedHoursReportComponent implements OnInit {
    @Input() ReportMainData: ReportMainData;
    constructor(private spinner: NgxSpinnerService, private reportService: ReportingService) { }
    ngOnInit(): void {
        this.spinner.show();
        this.spinner.hide();
      
    }
}